import React, { Component } from "react";
import {
  Table,
  Input,
  Button,
  Form,
  Tag,
  Badge,
  Checkbox,
  Select,
  Collapse ,
  TimePicker,
   message
} from "antd";
import PhoneInput,{isValidPhoneNumber,parsePhoneNumber} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { FaSave, FaTimes } from "react-icons/fa";
import { connect } from "react-redux";
import { AddOrUpdateFinancingRequest } from "../../network/customer.network";
import moment from "moment-hijri";
const { Panel } = Collapse;
class PropertyDetails extends Component {
  constructor(props){
    super(props);
    this.formRef = React.createRef();
  }
  state = {
    numberVal: "",
    btnLoading:false,
    ActiveKey : [],
    timePicker:''
  };

componentDidMount(){
  
  if(this.props.editMode){
    const {RequestDetails} = this.props;
    if(RequestDetails.RealestateFinancingRequest !== null && RequestDetails.PersonalFinancingRequest !== null) this.setState({ActiveKey : ['1','2']});
    else if(RequestDetails.RealestateFinancingRequest !== null) this.setState({ActiveKey : ['1']});
    else if(RequestDetails.PersonalFinancingRequest !== null) this.setState({ActiveKey : ['2']});
   else this.setState({ActiveKey : []});
    // RequestDetails.RealestateFinancingRequest !== null &&  this.onChangeCheckbox('1');
    // RequestDetails.PersonalFinancingRequest !== null && this.onChangeCheckbox('2');
     this.setState({timePicker:moment(RequestDetails.RealestateFinancingRequest?.TimeToContact).format('HH:mm:ss')});
    this.formRef.current.setFieldsValue({
      Amount: RequestDetails.PersonalFinancingRequest?.Amount,
      OwnerTypeId: RequestDetails.RealestateFinancingRequest?.OwnerTypeId,
      OwnerIdentityNumber: RequestDetails.RealestateFinancingRequest?.OwnerIdentityNumber,
      RealestateUrl: RequestDetails.RealestateFinancingRequest?.RealestateUrl,
      OwnerName: RequestDetails.RealestateFinancingRequest?.OwnerName,
      customerPhone: RequestDetails.RealestateFinancingRequest && ("+") +RequestDetails.RealestateFinancingRequest?.OwnerPhoneKey+RequestDetails.RealestateFinancingRequest?.OwnerPhoneNumber,
      RealestatePrice: RequestDetails.RealestateFinancingRequest?.RealestatePrice,
      InstrumentNo: RequestDetails.RealestateFinancingRequest?.InstrumentNo,
      RealestateCompleteProgress: RequestDetails.RealestateFinancingRequest?.RealestateCompleteProgress,
       TimeToContact: moment(RequestDetails.RealestateFinancingRequest?.TimeToContact, 'HH:mm:ss'),
      CityId: RequestDetails.RealestateFinancingRequest?.CityId
    });
  }
  else if(this.props.userRequest?.PersonalFinancingRequest || this.props.userRequest?.RealestateFinancingRequest){
    if(this.props.userRequest.RealestateFinancingRequest !== null && this.props.userRequest.PersonalFinancingRequest !== null) this.setState({ActiveKey : ['1','2']});
   else if(this.props.userRequest.RealestateFinancingRequest !== null) this.setState({ActiveKey : ['1']});
   else if(this.props.userRequest.PersonalFinancingRequest !== null) this.setState({ActiveKey : ['2']});
  else this.setState({ActiveKey : []});
    this.setState({timePicker:moment(this.props.userRequest.RealestateFinancingRequest?.TimeToContact).format('HH:mm:ss')});
   this.formRef.current.setFieldsValue({
     Amount: this.props.userRequest.PersonalFinancingRequest?.Amount,
     OwnerTypeId: this.props.userRequest.RealestateFinancingRequest?.OwnerTypeId,
     OwnerIdentityNumber: this.props.userRequest.RealestateFinancingRequest?.OwnerIdentityNumber,
     RealestateUrl: this.props.userRequest.RealestateFinancingRequest?.RealestateUrl,
     OwnerName: this.props.userRequest.RealestateFinancingRequest?.OwnerName,
     customerPhone: this.props.userRequest.RealestateFinancingRequest && ("+") +this.props.userRequest.RealestateFinancingRequest?.OwnerPhoneKey+this.props.userRequest.RealestateFinancingRequest?.OwnerPhoneNumber,
     RealestatePrice: this.props.userRequest.RealestateFinancingRequest?.RealestatePrice,
     InstrumentNo: this.props.userRequest.RealestateFinancingRequest?.InstrumentNo,
     RealestateCompleteProgress: this.props.userRequest.RealestateFinancingRequest?.RealestateCompleteProgress,
     TimeToContact: moment(this.props.userRequest.RealestateFinancingRequest?.TimeToContact, 'HH:mm:ss'),
     CityId: this.props.userRequest.RealestateFinancingRequest?.CityId
   });
 }
}



  onChangeCheckbox = (paneleKey) => {
    const {ActiveKey} = this.state;
    if(ActiveKey.includes(paneleKey)){
      this.setState({ActiveKey : ActiveKey.filter(k => k !== paneleKey)})
    }else{
      this.setState({ActiveKey : [...ActiveKey, paneleKey]})
    }
  }

  onFinish=(values)=>{
    if(this.props.editMode){
      this.setState({btnLoading:true});
      const phoneNumber =  parsePhoneNumber(values.customerPhone || "")
      let body = {
        Id: this.props.userData.Id,
       CustomerId: this.props.userData.CustomerId,
      PersonalFinancingRequest:!this.state.ActiveKey.includes("2")?null: {
          Id: 0,
          FinancingRequestId: 0,
          Amount: values.Amount
      },
      RealestateFinancingRequest:!this.state.ActiveKey.includes("1")?null: {
        Id: 0,
        FinancingRequestId: 0,
        OwnerTypeId: values.OwnerTypeId,
        OwnerIdentityNumber: values.OwnerIdentityNumber,
        RealestateUrl: values.RealestateUrl,
        OwnerName: values.OwnerName,
        OwnerPhoneNumber:values.customerPhone ? phoneNumber.nationalNumber :"",
        OwnerPhoneKey: values.customerPhone ? phoneNumber.countryCallingCode:"",
        RealestatePrice: values.RealestatePrice,
        InstrumentNo: values.InstrumentNo,
        RealestateCompleteProgress: values.RealestateCompleteProgress,
        TimeToContact: values.TimeToContact?.format('HH:mm:ss'),
        CityId: values.CityId
      }
    }
    AddOrUpdateFinancingRequest(body,(res)=>{
      message.success("تم تعديل الطلب بنجاح");
      this.props.handelShowInfo(body);
      this.setState({btnLoading:false});
    },(error)=>{
      message.error("حدث خطأ ما حاول مرة أخرى");
      this.setState({btnLoading:false});
    })
    }else{
      this.props.submitForm(values,this.state.ActiveKey);
    }
  }

  render() {
    const { showAdd } = this.props;
    const {ActiveKey} = this.state;
      
    return (
      <div className="finance-tab-content found-info">
        {!showAdd && <h2 className="tab-title">بيانات التمويل</h2>}
        {!showAdd && <span className="tab-span">اختر نوع التمويل الذي تريده</span>}
        <div className="finance-Collapse-wrapper">
        <Form className="form-add-content"
          layout="vertical"
          name="nest-messages"
          onFinish={this.onFinish}
          onFinishFailed={(e)=>console.log('sss',e)}
          id="orderForm1"
          ref={this.formRef}
        >
          <Collapse bordered={false} activeKey={ActiveKey}>
            <Panel header={<Checkbox checked={ActiveKey.includes("1")} onChange={() => this.onChangeCheckbox("1")}>تمويل عقاري</Checkbox>} key="1">
              
        {/* <Form
          className="form-add-content"
          layout="vertical"
          name="nest-messages"
          onFinish={this.props.submitForm}
          onFinishFailed={(e)=>console.log('sss',e)}
        > */}
        
          <div className="form-content">
            <Form.Item
              name="RealestateUrl"
              label="رابط العقار المقترح"
              className="input-holder"
              rules={[
                // {
                //   validator(_, value) {
                    
                //    if(!value && ActiveKey.includes("1")) return Promise.reject("من فضلك ادخل العقار المقترح");
                //    else return Promise.resolve();
                //   },
                // },
                {
                  type:"url",
                  message: "عنوان url لموقع الويب غير صالح",
              },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="نوع المالك"
              name="OwnerTypeId"
              className="input-holder"
            >
              <Select>
              {this.props.OwnerTypes.map((owner)=>{
                  return(<Select.Option key={owner.Id} value={owner.Id}>{owner.NameLT}</Select.Option>)
                })}
              </Select>
            </Form.Item>

            <Form.Item
              label="هويه المالك"
              name="OwnerIdentityNumber"
              className="input-holder"
              rules={[
                //{
                //   validator(_, value) {
                    
                //    if(!value && ActiveKey.includes("1")) return Promise.reject("من فضلك ادخل هوية المالك");
                //    else return Promise.resolve();
                //   },
                // },
                {
                  len:10,
                  message: "رقم الهوية يتكون من 10 أرقام",
                    
              },
              
              ]}
            >
                <Input type="number" placeholder=""/>
            </Form.Item>

            <Form.Item
              label="اسم المالك"
              name="OwnerName"
              className="input-holder"
            >
                <Input placeholder="" />
            </Form.Item>

            <Form.Item
                  label="رقم الجوال"
                  name="customerPhone"
                  className="input-holder"
                  rules={[
                    // {
                    //   required: true,
                    //   message: 'من فضلك ادخل رقم الجوال',
                    // },
                    // {
                    //   validator(_, value) {
                    //     let phoneValid = isValidPhoneNumber(value || "");
                    //    if(!value && ActiveKey.includes("1")) return Promise.reject("من فضلك ادخل رقم الجوال");
                    //    else if(!phoneValid && ActiveKey.includes("1")) return Promise.reject("رقم الجوال غير صحيح");
                    //    else return Promise.resolve();
                    //   },
                    // } 
                  ]}
                >
                  <PhoneInput
                    international
                    countryCallingCodeEditable={false}
                    // labels={{ SA: "Saudi Arabia"}}
                    defaultCountry="SA"
                    value={this.state.numberVal}
                    onChange={(val) =>this.setState({numberVal : val})}
                  />
                </Form.Item>


                <Form.Item
              label="الوقت المناسب للاتصال"
              name="TimeToContact"
              className="input-holder"
            >
                 <TimePicker placeholder="" format="HH:mm:ss" value={this.state.timePicker}/> 
            </Form.Item>

                <Form.Item
              label="سعر العقار الفعلي"
              name="RealestatePrice"
              className="input-holder input-holder-mask"
            >
                <Input placeholder="" type="number" suffix="ر.س" />
            </Form.Item>

            <Form.Item
              label="نسبة اكتمال بناء العقار"
              name="RealestateCompleteProgress"
              className="input-holder input-holder-mask"
            >
                <Input placeholder="" suffix="%" />
            </Form.Item>

                <Form.Item
              label="رقم الصك"
              name="InstrumentNo"
              className="input-holder input-holder-mask"
            >
                <Input placeholder="" type="number" />
            </Form.Item>

            <Form.Item
              label="مدينة العقار"
              name="CityId"
              className="input-holder"
            > 
              <Select>
                {this.props.Cities?.map((city)=>{
                  return(<Select.Option key={city.Id} value={city.Id}>{city.NameLT}</Select.Option>)
                })}
              </Select>
            </Form.Item>
          </div>
          
        {/* </Form> */}
            </Panel>
            <Panel header={<Checkbox checked={ActiveKey.includes("2")} onChange={() => this.onChangeCheckbox("2")}>تمويل شخصي</Checkbox>} key="2">
            {/* <Form
          className="form-add-content"
          layout="vertical"
          name="personal"
          onFinish={this.props.submitForm}
          id="orderForm2"
        > */}
        
          <div className="form-content">
          <Form.Item
              label="مبلغ التمويل الشخصي"
              name="Amount"
              className="input-holder input-holder-mask"
              rules={[
                {
                  validator(_, value) {
                   if(!value && ActiveKey.includes("2")) return Promise.reject("من فضلك ادخل مبلغ التمويل");
                   else return Promise.resolve();
                  },
                },
              ]}
            >
                <Input placeholder="" type="number" suffix="ر.س" />
            </Form.Item>
            </div>
          
            </Panel>
          </Collapse>
           

          {showAdd && (
            <div className="form-add-btns">
              <Button
                type="primary"
                size="large"
                className="blue-btn xlg"
                icon={<FaSave />}
                loading={this.state.btnLoading}
                htmlType="submit"
              >
                حفظ
              </Button>
              <Button
                type="primary"
                size="large"
                className="red-btn xlg"
                onClick={() => this.props.handelShowInfo(null)}
                icon={<FaTimes />}
              >
                الغاء
              </Button>
            </div>
          )}
           </Form>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Cities : state.user.metaData?.Cities,   
  OwnerTypes : state.user.metaData?.OwnerTypes,   
  Banks : state.user.metaData?.Banks, 
  Genders : state.user.metaData?.Genders, 
  RequestDetails:state.order?.RequestDetails,
  userRequest : state.user?.userRequest
}) 
export default connect(mapStateToProps)(PropertyDetails);  
